<template>
<button
  class="cursor-pointer inline-flex items-center px-2 py-2 border border-gray-200 rounded-md font-semibold text-xs uppercase tracking-widest hover:bg-gray-300 focus:bg-gray-300 active:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition ease-in-out duration-150"
>
  <slot />
</button>
</template>
